import { transliterateCarNumber } from './transliterate-car-number'

const LETTERS = 'АВЕКМНОРСТУХ'

const STANDARD_CAR_NUMBER_REGEX = new RegExp(`^[${LETTERS}][0-9]{3}[${LETTERS}]{2}[0-9]{2,3}$`)

export function formatCarNumber(input: string): string {
    if (!input) return ''

    if (!STANDARD_CAR_NUMBER_REGEX.test(input)) {
        return input
    }

    const cleaned = transliterateCarNumber(input, 'latin-to-cyrillic')
        .replace(/[^А-Я0-9]/gi, '')
        .toUpperCase()

    return `${cleaned[0]} ${cleaned.slice(1, 4)} ${cleaned.slice(4, 6)} ${cleaned.slice(6)}`
}
